import React from "react";

import s from "./ui.module.scss";

interface PageHeaderProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  /** Right-aligned actions (e.g. an "Add" button). */
  actions?: React.ReactNode;
  className?: string;
}

const PageHeader = ({ title, description, actions, className }: PageHeaderProps) => (
  <div className={[s.pageHeader, className].filter(Boolean).join(" ")}>
    <div className={s.pageHeaderText}>
      <h1 className={s.pageTitle}>{title}</h1>
      {description && <p className={s.pageDesc}>{description}</p>}
    </div>
    {actions && <div className={s.pageActions}>{actions}</div>}
  </div>
);

export default PageHeader;
